import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Alert, Button } from 'react-bootstrap'

const FetchError = (props)  =>

	<div className="notFoundPage">
	<br/>
		
		<Alert bsStyle="danger" >

			<h4><FormattedMessage id="fetchError.lesson" defaultMessage="Somthing went wrong fetching data:" /> {props.error.name}</h4>
			<FormattedMessage id="fetchError.lesson" defaultMessage="Error message:" />
			<br/>
			<pre>{props.error.message }</pre>
		</Alert>
		<Button className="reviewButton" onClick={() => {window.location.reload()}}  >
			<FormattedMessage id='viewer.refresh' defaultMessage='Refresh' /> 
		</Button>
	</div>


export default FetchError;